<script>
export const group = 'Full'
</script>

<script setup>
import TextSlideUp from './text_animations/TextSlideUp.vue'
import CharacterEnlarge from './text_animations/CharacterEnlarge.vue'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import { computed } from 'vue'
import { frames } from '../../../utils/frames'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import { colors } from '../../../tailwindTheme.config'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import AnimatedBackground from '../../AnimatedBackground.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const timelineSubtitle = ref(null)
const timelineSubtitleOut = ref(null)
const timelineTitle = ref(null)
const timelineNextAttempt = ref(null)

const scoreIconsElement = ref(null)

onMounted(() => {
  return gsapTimeline({ name: 'EscapeRoomScoreFull' })
    .add(timelineSubtitle)
    .add(timelineTitle, `<${frames(14)}`)
    .from(scoreIconsElement.value.children, { scale: 0.5, opacity: 0, yPercent: 30, duration: frames(14), transformOrigin: 'center center', stagger: frames(3), ease: 'back.out' }, `<${frames(8)}`)
    .add(timelineNextAttempt, `<${frames(4)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value.reverse()
  timelineNextAttempt.value.reverse()

  return await gsapTimeline({ name: 'EscapeRoomScoreFull - End' })
    .to(scoreIconsElement.value.children, { scale: 0, opacity: 0, yPercent: 50, duration: frames(10), transformOrigin: 'center center', stagger: -1 * frames(2), ease: 'back.in' }, '<')
    .add(timelineSubtitleOut.value(), '<')
    .add(timelineNextAttempt, '<')
    .add(timelineTitle, '<')
})

const mostRecentAttempt = computed(() => item.enrichment?.mostRecentAttempt || null)
const nextAttempt = computed(() => item.enrichment?.nextAttempt || null)
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="2" :position="{ x: 900, y: 498 }" :backgroundColor="colors.q.cr.gray.primary" :color="colors.q.cr.gray.darker">
      <div class="h-full flex items-center justify-center">
        <div :style="{ transform: 'scale(2)', transformOrigin: 'center' }">
          <div class="text-white space-y-8 w-[52rem]">
            <div class="text-white space-y-8 flex flex-col items-center text-center">
              <div>
                <TextSlideUp
                  :text="`${mostRecentAttempt.correctAnswers} ${mostRecentAttempt.correctAnswers === 1 ? 'track' : 'tracks'} gekraakt`"
                  class="text-7xl font-bold leading-none font-cervo text-q-cr-red-primary"
                  @timeline="timelineSubtitle = $event"
                  @timelineOut="timelineSubtitleOut = $event"
                />

                <CharacterJumpFromTheRight :text="`Muzikale Code`" class="text-white mb-1" textSizeClass="text-8xl" @timeline="timelineTitle = $event" />
              </div>

              <div ref="scoreIconsElement" class="flex items-center justify-center gap-6">
                <svg v-for="i in mostRecentAttempt.correctAnswers" :key="`correct-${i}`" viewBox="0 0 24 24" stroke-width="1.5" class="fill-none stroke-current text-white w-24 h-24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                <svg v-for="i in 4 - mostRecentAttempt.correctAnswers" :key="`incorrect-${i}`" viewBox="0 0 24 24" stroke-width="1.5" class="fill-none stroke-current text-q-cr-red-primary w-24 h-24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              </div>

              <CharacterEnlarge
                :text="nextAttempt ? `De volgende poging is ${nextAttempt.humanReadableDate}` : ''"
                class="text-white font-cervo font-bold text-4xl"
                @timeline="timelineNextAttempt = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
